import React from 'react'
import Lottie from 'lottie-react'
import errorAnimation from '../../../public/errorAnimation.json'

const ErrorAnimation = () => {
  return (
    <Lottie animationData={errorAnimation} className='w-96 h-72'/>
  )
}

export default ErrorAnimation